var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page',{attrs:{"title":_vm.title,"breadcrumb":_vm.breadcrumb,"load":_vm.doInit}},[_c('v-card',[_c('transition',{attrs:{"name":"slide-x-transition","mode":"out-in"}},[_c('router-view',{attrs:{"routerKey":_vm.routerKey}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }